/**
 * Created by alvinoktavianus on 7/4/17.
 */

import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

import {
  confirmReactivateOutletWithoutPay,
  hideReactivateOutletWithoutPay,
} from 'actions/outletPages/list';
import styles from './ReactivateOutletWithoutPayModal.css';

class ReactivateOutletWithoutPayModal extends Component {
  render() {
    const { showReactivateOutletWithoutPayModal, isOnLoading } = this.props;
    return (
      <Modal
        onHide={() => {
          this._onHide();
        }}
        show={showReactivateOutletWithoutPayModal}
        dialogClassName={`${styles.dialog} modal-dialog`}
      >
        <Modal.Header>
          <Modal.Title>Reactivate Outlet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p>
              Are you sure want to reactivate this outlet? This action cannot be
              reversed.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              className="btn btn-default"
              onClick={() => {
                this._onHide();
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary pull-right"
              onClick={() => {
                this._onConfirm();
              }}
              disabled={isOnLoading}
            >
              Reactivate
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  _onHide = () => {
    this.props.dispatch(hideReactivateOutletWithoutPay());
  };

  _onConfirm = () => {
    const { reactivatedOutlet, outlets } = this.props;
    this.props.dispatch(
      confirmReactivateOutletWithoutPay(reactivatedOutlet, outlets)
    );
  };
}

function mapStateToProps(state) {
  const {
    showReactivateOutletWithoutPayModal,
    reactivatedOutlet,
    outlets,
    isOnLoadingReactivateOutletWithoutPayModal,
  } = state.outletPages.list;
  return {
    showReactivateOutletWithoutPayModal,
    reactivatedOutlet,
    outlets,
    isOnLoading: isOnLoadingReactivateOutletWithoutPayModal,
  };
}

export default connect(mapStateToProps)(ReactivateOutletWithoutPayModal);
